import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { IFilterNumber } from '@shared/models/graphql';
import { IPropertiesFilters } from '@shared/models/filters';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import {
  setUnsavedBedroomsFiltersAction,
  setUnsavedBathroomsFiltersAction,
  setUnsavedSquareFootFiltersAction,
  setUnsavedLotSizeFiltersAction,
  setUnsavedYearBuiltFiltersAction,
} from '@state/filters/filters.actions';
import { selectFiltersCurrent } from '@state/filters/filters.selectors';

import { FilterV2BedsComponent } from '../filter-v2-beds/filter-v2-beds.component';
import { FilterV2BathsComponent } from '../filter-v2-baths/filter-v2-baths.component';
import { FilterV2SqftComponent } from '../filter-v2-sqft/filter-v2-sqft.component';
import { FilterV2LotSizeComponent } from '../filter-v2-lot-size/filter-v2-lot-size.component';
import { FilterV2YearBuiltComponent } from '../filter-v2-year-built/filter-v2-year-built.component';

@UntilDestroy()
@Component({
  selector: 'app-filter-v2-more-desktop',
  templateUrl: './filter-v2-more-desktop.component.html',
  styleUrls: [
    './filter-v2-more-desktop.component.scss',
    '../filters-v2.component.scss',
  ],
})
export class FilterV2MoreDesktopComponent implements OnInit {
  @Output() applyFilters = new EventEmitter();
  @ViewChild('trigger') menuTrigger!: MatMenuTrigger;
  @ViewChild(FilterV2BedsComponent) bedsFilter!: FilterV2BedsComponent;
  @ViewChild(FilterV2BathsComponent) bathsFilter!: FilterV2BathsComponent;
  @ViewChild(FilterV2SqftComponent) squareFootFilter!: FilterV2SqftComponent;
  @ViewChild(FilterV2LotSizeComponent) lotSizeFilter!: FilterV2LotSizeComponent;
  @ViewChild(FilterV2YearBuiltComponent)
  yearBuiltFilter!: FilterV2YearBuiltComponent;

  protected isOpen = false;
  protected isActive = false;
  protected checkedCount = 0;

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.store
      .select(selectFiltersCurrent)
      .pipe(untilDestroyed(this))
      .subscribe((filters) => {
        if (this.verifyIfActive(filters?.bedrooms)) {
          this.isActive = true;
        } else if (this.verifyIfActive(filters?.bathrooms)) {
          this.isActive = true;
        } else if (this.verifyIfActive(filters?.squareFoot)) {
          this.isActive = true;
        } else if (this.verifyIfActive(filters?.lotSize)) {
          this.isActive = true;
        } else if (this.verifyIfActive(filters?.yearBuilt)) {
          this.isActive = true;
        } else {
          this.isActive = false;
        }

        this.updateCheckedCount(filters);
      });
  }

  updateCheckedCount(filters: IPropertiesFilters | undefined) {
    let count = 0;
    if (this.verifyIfActive(filters?.bedrooms)) {
      count++;
    }
    if (this.verifyIfActive(filters?.bathrooms)) {
      count++;
    }
    if (this.verifyIfActive(filters?.squareFoot)) {
      count++;
    }
    if (this.verifyIfActive(filters?.lotSize)) {
      count++;
    }
    if (this.verifyIfActive(filters?.yearBuilt)) {
      count++;
    }
    this.checkedCount = count;
  }

  verifyIfActive(filter?: IFilterNumber): boolean {
    if (filter) {
      if (filter.greaterThanOrEqual || filter.lessThanOrEqual) {
        return true;
      }
    }
    return false;
  }

  handleReset(apply: boolean = true): void {
    this.menuTrigger.closeMenu();

    if (apply) {
      this.store.dispatch(setUnsavedBedroomsFiltersAction({}));
      this.store.dispatch(setUnsavedBathroomsFiltersAction({}));
      this.store.dispatch(setUnsavedSquareFootFiltersAction({}));
      this.store.dispatch(setUnsavedLotSizeFiltersAction({}));
      this.store.dispatch(setUnsavedYearBuiltFiltersAction({}));
      this.applyFilters.emit();
    } else {
      this.bedsFilter.loadInitialValue();
      this.bathsFilter.loadInitialValue();
      this.squareFootFilter.loadInitialValue();
      this.lotSizeFilter.loadInitialValue();
      this.yearBuiltFilter.loadInitialValue();
    }
  }

  handleApply(): void {
    this.applyFilters.emit();
    this.menuTrigger.closeMenu();
  }
}
